import apiService from './ApiService';

class PresenciaApiService {
  async getOnlineUsers({ rol, tipoTenant, colegioId, profesorParticularId, search, page, pageSize } = {}) {
    const params = new URLSearchParams();
    if (rol && rol !== 'todos') params.append('rol', rol);
    if (tipoTenant && tipoTenant !== 'todos') params.append('tipoTenant', tipoTenant);
    if (colegioId) params.append('colegioId', colegioId);
    if (profesorParticularId) params.append('profesorParticularId', profesorParticularId);
    if (search) params.append('search', search);
    if (page) params.append('page', page);
    if (pageSize) params.append('pageSize', pageSize);
    const qs = params.toString();
    return apiService.get(`/presencia/usuarios-en-linea${qs ? `?${qs}` : ''}`);
  }
}

const presenciaApiService = new PresenciaApiService();

export default presenciaApiService;
